"use client"

import type { ReactNode } from 'react'
import { usePublicShell } from '../hooks/use-landing'
import { EditorialHeader } from './editorial-header'
import { EditorialFooter } from './editorial-footer'
import s from '../styles/landing.module.css'

export function PublicShell({ children }: { children: ReactNode }) {
  const { isHome, isLogin, pathname } = usePublicShell()
  if (isHome) return children
  return <div id="top" className={`${s.page} ${s.publicPage}`}>
    <EditorialHeader key={pathname} isHome={false} isLogin={isLogin} />
    {children}
    <EditorialFooter />
  </div>
}
